// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"wp-z","badgeLink":"xp-z","category":"yp-z"};